import api from "./axios";

export const fetchNewQuotationFields = async (leadId) => {
  return api.get(`/quotations/new/${leadId}`);
};

export const createQuotation = async (data) => {
  return api.post("/quotations", data);
};

export const fetchQuotationById = async (id) => {
  return api.get(`/quotations/${id}`);
};

export const updateQuotation = async (id, data) => {
  return api.put(`/quotations/${id}`, data);
};

export const deleteQuotation = async (id) => {
  return api.delete(`/quotations/${id}`);
};

export const openQuotationPdf = async (quotationId, revisionId) => {
  // The axios interceptor unwraps response.data, so we get the blob directly
  const blob = await api.get(
    `/quotations/${quotationId}/revisions/${revisionId}/pdf`,
    { responseType: "blob" },
  );

  const pdfBlob = new Blob([blob], { type: "application/pdf" });
  const url = window.URL.createObjectURL(pdfBlob);
  window.open(url, "_blank");
};
